import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialBlockXingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialBlockXing",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.99 24.75A5.3 5.3 0 0 1 24.75 30H7.24c-2.88-.04-5.21-2.37-5.24-5.24V7.25A5.31 5.31 0 0 1 7.23 2h17.5a5.3 5.3 0 0 1 5.25 5.24v17.51zM12.2 9.57a1.07 1.07 0 0 0-.95-.63H7.84c-.17 0-.32.07-.42.19-.05.08-.07.17-.07.27s.03.19.08.27 2.28 3.93 2.28 3.93l-3.58 6.36c-.05.07-.08.16-.08.25s.03.18.08.26c.09.14.25.23.42.23h3.39c.41-.03.76-.29.91-.65 3.49-6.17 3.6-6.37 3.6-6.37l-2.28-4.05zm13.21-5.25H22c-.41.03-.75.29-.9.64-7.22 12.89-7.47 13.31-7.47 13.31l4.78 8.77c.16.38.53.64.95.65h3.38c.17 0 .32-.08.41-.21.05-.07.08-.16.08-.26s-.03-.18-.08-.26-4.74-8.71-4.74-8.71l7.42-13.18c.05-.07.07-.16.07-.25s-.03-.18-.07-.26a.41.41 0 0 0-.36-.21h-.06z"
    })
  }));
};
SocialBlockXingIcon.displayName = 'SocialBlockXingIcon';